import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Appointment from '../sections/Appointment/Appointment';
import Banner from '../sections/Banner/Banner';
import Features from '../sections/Features/Features';
import Footer from '../sections/Footer/Footer';
import Services from '../sections/Services/Services';
import Accredited from '../sections/Accredited/Accredited';
import SEO from '../components/SEO';
import ServicesData from '../sections/Services/ServiceData';

const Home = ({ lang = 'en' }) => {
  const BASE_URL = "https://alsaketdental.com";
  const SITE_NAME = "AlSaket Dental Clinics";
  const SITE_NAME_AR = "عيادات الساكت لطب الأسنان";

  const isArabic = lang === 'ar';
  const pageUrl = `${BASE_URL}/${lang}`;

  // JSON-LD: Organization (Bilingual)
  const organizationLD = {
    "@context": "https://schema.org",
    "@type": "Dentist",
    "name": "AlSaket Dental Clinics",
    "alternateName": "عيادات الساكت لطب الأسنان",
    "url": BASE_URL,
    "logo": `${BASE_URL}/images/logo.png`,
    "image": `${BASE_URL}/images/og-image.jpg`,
    "description": "Professional dental care services in Amman, Jordan. Specializing in orthodontics, implants, whitening, and comprehensive dental treatments.",
    "description_ar": "خدمات طب الأسنان المهنية في عمان، الأردن. متخصصون في تقويم الأسنان، الزراعة، التبييض، والعلاجات الشاملة للأسنان.",
    "sameAs": [
      "https://www.facebook.com/alsaketdental",
      "https://www.instagram.com/alsaketdental"
    ],
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Amman, Jordan",
      "addressLocality": "Amman",
      "addressRegion": "Amman",
      "addressCountry": "JO",
      "postalCode": "11183"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "31.9539",
      "longitude": "35.9106"
    },
    "telephone": "+962-79-2602666",
    "email": "info@alsaketdental.com",
    "openingHours": "Mo-Fr 09:00-18:00, Sa 09:00-14:00",
    "priceRange": "$$",
    "currenciesAccepted": "JOD",
    "paymentAccepted": "Cash, Credit Card, Insurance"
  };

  // JSON-LD: Services dynamically from ServicesData
  const servicesLD = {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "name": SITE_NAME,
    "url": BASE_URL,
    "service": ServicesData.map(service => ({
      "@type": "MedicalProcedure",
      "name": service.title,
      "description": service.description
    }))
  };

  // JSON-LD: AppointmentAction
  const appointmentLD = {
    "@context": "https://schema.org",
    "@type": "MedicalAppointment",
    "name": "Book Appointment",
    "description": "Book your appointment easily via WhatsApp with the best dentists in Amman.",
    "url": "https://api.whatsapp.com/send?phone=+962792602666&text=Hello%20doctor%20can%20I%20book%20an%20appointment?"
  };

  // JSON-LD: ContactPoint
  const contactPointLD = {
    "@context": "https://schema.org",
    "@type": "ContactPoint",
    "contactType": "customer service",
    "email": "info@alsaketdental.com",
    "telephone": "+962792602666",
    "areaServed": "JO",
    "availableLanguage": ["Arabic", "English"]
  };

  return (
    <>
      {/* SEO متكامل للصفحة - Bilingual */}
      <SEO
        title="AlSaket Dental Clinics - Professional Dental Care in Amman"
        titleAr="عيادات الساكت لطب الأسنان - رعاية أسنان مهنية في عمان"
        description="Professional dental care services in Amman, Jordan. Specializing in orthodontics, implants, whitening, root canal treatment, and comprehensive dental solutions with experienced specialists."
        descriptionAr="خدمات طب الأسنان المهنية في عمان، الأردن. متخصصون في تقويم الأسنان، الزراعة، التبييض، علاج العصب، والحلول الشاملة للأسنان مع أطباء متخصصين."
        keywords={[
          "dental clinic amman", 
          "dentist amman", 
          "orthodontics jordan", 
          "dental implants amman", 
          "teeth whitening amman",
          "root canal treatment amman",
          "dental care jordan",
          "professional dentist amman"
        ]}
        keywordsAr={[
          "عيادات الأسنان عمان", 
          "طبيب أسنان عمان", 
          "تقويم الأسنان الأردن", 
          "زراعة الأسنان عمان", 
          "تبييض الأسنان عمان",
          "علاج العصب عمان",
          "رعاية الأسنان الأردن",
          "طبيب أسنان متخصص عمان"
        ]}
        url={pageUrl}
        image={`${BASE_URL}/images/og-image.jpg`}
        siteName={SITE_NAME}
        siteNameAr={SITE_NAME_AR}
        structuredData={[organizationLD, servicesLD, appointmentLD, contactPointLD]}
        lang={isArabic ? 'ar' : 'en'}
      />

      {/* أقسام الصفحة */}
      <Navbar />
      <Banner />
      <Services />
      {/* <Emergency/> */}
      <Features />
      {/* <Expert/> */}
      {/* <Testimonial/> */}
      {/* <Blogs/> */}
      <Accredited />
      <Appointment />
      <Footer />
    </>
  );
};

export default Home;
